import { TCountryCode } from 'countries-list';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type StoreSettingsState = {
  countryCode?: TCountryCode | 'global';
  setCountryCode: (countryCode: TCountryCode | 'global') => void;
};

export const useSettings = create<StoreSettingsState>()(
  persist(
    (set) => ({
      countryCode: undefined,
      setCountryCode: (countryCode: TCountryCode | 'global') =>
        set({ countryCode }),
    }),
    {
      name: 'puzzle-store-settings-storage',
      migrate: (persistedState: any) => {
        // Remove the old field from persisted state
        const {
          showProductsForAllCountries,
          setShowProductsForAllCountries,
          ...rest
        } = persistedState;
        return rest;
      },
      version: 2,
    }
  )
);

type StoreChallengeAuthState = {
  challengeAuth?: string;
  auth?: string;
  setChallengeAuth: (challengeAuth: string) => void;
  setAuth: (auth: string) => void;
};

export const useAuth = create<StoreChallengeAuthState>()(
  persist(
    (set) => ({
      challengeAuth: undefined,
      setChallengeAuth: (challengeAuth) => set({ challengeAuth }),
      auth: undefined,
      setAuth: (auth) => set({ auth }),
    }),
    {
      name: 'puzzle-store-auth-storage',
      storage: createJSONStorage(() => {
        // Check if we're in iOS WebView
        const isWebview = /PuzzleWallet/i.test(navigator.userAgent);
        // Use localStorage for iOS WebView, sessionStorage otherwise
        return isWebview ? localStorage : sessionStorage;
      }),
    }
  )
);
